import React from 'react';
import { Input } from 'antd';
import { GlobalVariable, MultilineTextSettings } from '@kemu-io/kemu-core/common/managers/globalVariables.js';
import { DataType, SupportedTypes } from '@kemu-io/hs-types';
import styles from '../GlobalVariablesPanel.module.css';
import { useTranslation } from '@hooks/index';

type Props = {
  variable: GlobalVariable;
  onChange: (name: string,value: SupportedTypes, type: DataType) => void;
}

/**
 * Multiline text control component for global variables
 * @param variable - The global variable configuration
 * @param onChange - Callback when value changes
 */
const MultilineTextControl = ({ variable, onChange }: Props) => {
  const settings = variable.controlSettings as MultilineTextSettings;
  const currentValue = variable.lastValue as string ?? '';
  const t = useTranslation('GlobalVariablesPanel.MultilineTextControl');

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(variable.name, e.target.value, DataType.String);
  };

  return (
    <Input.TextArea
      value={currentValue}
      onChange={handleChange}
      placeholder={settings.placeholder || t('Placeholder')}
      className={styles.ControlTextarea}
    />
  );
};

export default MultilineTextControl;
